import React from 'react';
import trustpilot from '../assets/images/trustpilot.png';

const TestimonialCard = ({ name, treatment, rating, testimonial }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h3 className="text-xl font-bold mb-1 font-heading">{name}</h3>
      <p className="text-gray-600 mb-2">{treatment}</p>
      <div className="flex text-yellow-400 mb-3">
        {[...Array(rating)].map((_, i) => (
          <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
      <p className="text-gray-700 italic">"{testimonial}"</p>
    </div>
  );
};

const Testimonials = () => {
  const testimonials = [
    {
      name: "John",
      treatment: "Tooth Extraction",
      rating: 5,
      testimonial: "Rapid treatment, clear costs before I arrived and very happy with the end result. Would recommend."
    },
    {
      name: "Maria",
      treatment: "Root Canal",
      rating: 5,
      testimonial: "Thought I'd be in for a painful weekend until Monday but had treatment done quickly and relatively inexpensive given the emergency timeline!"
    },
    {
      name: "Jane",
      treatment: "Toothache",
      rating: 5,
      testimonial: "Nothing worse than bad toothache, so getting booked in for rapid treatment was really helpful. Thank you!"
    }
  ];

  return (
    <div className="py-16 bg-neutral/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-heading mb-4">Our Testimonials</h2>
          <p className="text-xl text-gray-700">We've helped over 1,500 People</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard 
              key={index}
              name={testimonial.name}
              treatment={testimonial.treatment}
              rating={testimonial.rating}
              testimonial={testimonial.testimonial}
            />
          ))}
        </div>
        
        <div className="mt-12 flex justify-center">
          <img src={trustpilot} alt="Trustpilot" className="h-12" />
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
